import { Currency } from '@teko/ds-desktop';
import { StyledCurrency } from 'components/ProductDetail/styles';
import { useTenantConfig } from 'contexts';
import { t } from 'i18n';
import React from 'react';
import { ProductDetailPromotionV2 } from '../types';

export interface RelatedPromotionV2Props {
  validPromotion: ProductDetailPromotionV2;
}

const renderDetailPromotionContent = (
  benefit: ProductDetailPromotionV2['benefit'],
  isCoupon: boolean,
  showGiftValueInRelatedPromotions?: boolean,
) => {
  const { gifts, voucher, discount } = benefit;
  const renderAndText = ' ' + t('và') + ' ';

  const renderDiscount = () => {
    if (discount && Object.keys(discount).length) {
      const { percent, maxAmount, flat } = discount;
      return percent !== null ? (
        <>
          {t('{{percent}}% ', { percent: percent })}
          {!!maxAmount && (
            <>
              {t('tối đa')} <StyledCurrency value={maxAmount} />
            </>
          )}
        </>
      ) : (
        <StyledCurrency value={flat || 0} />
      );
    }
  };

  const renderGifts = () => {
    if (gifts && gifts.length) {
      return (
        <>
          {gifts.map(({ name, quantity, imageUrl, sellPrice }, index) => (
            <React.Fragment key={`${index}${name}`}>
              <strong>{` ${quantity} ${name}`}</strong>
              {!!showGiftValueInRelatedPromotions && !!sellPrice && (
                <strong>
                  {` ${t('trị giá')}`} <Currency value={sellPrice} />
                </strong>
              )}
              {!!imageUrl && (
                <img
                  style={{
                    objectFit: 'contain',
                    height: '20px',
                    width: '20px',
                  }}
                  src={imageUrl}
                  alt={name}
                />
              )}
              {index !== gifts.length - 1 && ', '}
            </React.Fragment>
          ))}
        </>
      );
    }
    return null;
  };

  const renderVoucher = () => {
    if (voucher && Object.keys(voucher).length) {
      return (
        <strong>
          {voucher.name ? `${voucher.quantity} ${voucher.name}` : 'Voucher'}
        </strong>
      );
    }
    return null;
  };
  const content = (
    <>
      {renderDiscount() && t('giảm') + ' '}
      {renderDiscount()}
      {renderDiscount() && renderGifts() && renderAndText}
      {renderGifts() && t('tặng')}
      {renderGifts()}
      {renderDiscount() && renderVoucher() && !renderGifts() && renderAndText}
      {renderGifts() && renderVoucher() && ', '}
      {renderVoucher() && !renderGifts() && t('tặng')} {renderVoucher()}
    </>
  );
  if (!isCoupon) {
    let spinner = true;
    return React.cloneElement(content, {
      children: React.Children.map(content.props.children, (element) => {
        if (typeof element === 'string' && spinner) {
          if (!!element) {
            spinner = false;
            return element.charAt(0).toUpperCase() + element.slice(1);
          }
        }
        return element;
      }),
    });
  }
  return content;
};

export const RelatedPromotionV2: React.FunctionComponent<
  RelatedPromotionV2Props
> = ({ validPromotion }: RelatedPromotionV2Props) => {
  const { showGiftValueInRelatedPromotions } = useTenantConfig();
  const { isDefault, benefit, condition, type, description } = validPromotion;
  const isCoupon = !isDefault && type === 'coupon';
  const isGiftCode = !isDefault && type === 'gift-code';
  // Custom magento from PPM
  if (type === 'qr') {
    return (
      <span
        dangerouslySetInnerHTML={{
          __html: description || '',
        }}
      ></span>
    );
  }
  return (
    <span>
      {(isCoupon || isGiftCode) && (
        <>
          {t('Nhập mã')} <strong>{condition?.coupon || ''}</strong>{' '}
        </>
      )}
      {renderDetailPromotionContent(
        benefit,
        isCoupon || isGiftCode,
        showGiftValueInRelatedPromotions,
      )}{' '}
      {t('cho đơn hàng')}{' '}
      {!!condition?.orderValueMin && (
        <>
          {t('từ')} <Currency value={condition.orderValueMin} />
        </>
      )}
      {!!condition?.orderValueMax && (
        <>
          {' '}
          {t('đến')} <Currency value={condition.orderValueMax} />
        </>
      )}{' '}
      {!!condition?.hasProductCondition && t('có sản phẩm này')}
      {isDefault && t('sites.shop-front.components.RelatedPromotion.0')}
    </span>
  );
};
